const equipmentChangeStatusInput = {
  activeTitle: 'EQUIPMENT',
  activeTitleTrue: 'INACTIVATE',
  activeTitleFalse: 'REACTIVATE',
  maintenanceTitle: 'MAINTENANCE',
  maintenanceTitleTrue: 'RETURN FROM',
  maintenanceTitleFalse: 'SEND TO',
};

export default equipmentChangeStatusInput;
